import React, { useMemo } from "react"
import { MdOutlineCompareArrows, MdOutlineHistory } from "react-icons/md"
import Modal from "../index"
import Button from "../../Form/Button"
import { buildAgentVersionComparison } from "./agentVersionComparison"
import styles from "./modalAgent.module.css"

const ModalAgentVersionComparison = ({ agent, fixedResponses = [], version, restoring = false, closeModal, onRestore }) => {
    const comparison = useMemo(() => buildAgentVersionComparison(
        { ...agent, fixed_responses: fixedResponses },
        version?.snapshot || {}
    ), [agent, fixedResponses, version])
    const changed = comparison.filter(item => item.changed)

    return (
        <Modal
            icon={<MdOutlineHistory />}
            title={`Comparar com a versão ${version.version}`}
            description="Revise o que será alterado antes de restaurar"
            closeModal={closeModal}
            bodyClassName={styles.versionComparisonModalBody}
        >
            <div className={styles.versionComparisonSummary}>
                <MdOutlineCompareArrows />
                <div>
                    <strong>{changed.length ? `${changed.length} ${changed.length === 1 ? "área será alterada" : "áreas serão alteradas"}` : "Nenhuma área será alterada"}</strong>
                    <span>A configuração atual será guardada no histórico e a versão escolhida será aplicada como uma nova versão.</span>
                </div>
            </div>

            <div className={styles.versionComparisonLegend}>
                <span>Versão atual salva</span>
                <span>Versão {version.version}, selecionada</span>
            </div>
            <section className={styles.versionComparisonList}>
                {comparison.map(item => (
                    <article key={item.id} className={item.changed ? styles.versionComparisonChanged : styles.versionComparisonUnchanged}>
                        <header>
                            <strong>{item.label}</strong>
                            <small>{item.changed ? "Será alterado" : "Sem alteração"}</small>
                        </header>
                        <div>
                            <p>{item.current}</p>
                            <MdOutlineCompareArrows />
                            <p>{item.selected}</p>
                        </div>
                        {item.changed && item.detail && <p className={styles.versionComparisonDetail}>{item.detail}</p>}
                    </article>
                ))}
            </section>

            <div className={styles.versionComparisonNotice}>
                Alterações ainda não salvas nesta tela não fazem parte do histórico e serão descartadas ao restaurar.
            </div>
            <footer className={styles.versionComparisonActions}>
                <Button type="button" variant="secondary" fullWidth={false} disabled={restoring} onClick={closeModal}>Cancelar</Button>
                <Button type="button" variant="primary" fullWidth={false} disabled={restoring} onClick={onRestore}>
                    {restoring ? "Restaurando..." : `Restaurar versão ${version.version}`}
                </Button>
            </footer>
        </Modal>
    )
}

export default ModalAgentVersionComparison
